import axios from 'axios'
import { errorHandler } from '@/api/error-handler'
const BASE_URL = '/api'
export default {
  requestToken: (username, password) => (
    axios.post('/auth/token', { email: username, password: password })
      .then(response => response.data)
      .catch(error => errorHandler(error))
  ),

  refreshToken: (refreshToken, myerrorHandler) => (
    axios.post('/auth/refresh', { refresh: refreshToken })
      .then(response => response.data)
      .catch(error => myerrorHandler(error))
  ),

  createAccountParameter: (errorHandling = false) => axios.get(`${BASE_URL}/users_params`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  resetPassword: (email) => (
    axios.post('/reset_password', { email: email })
      .then(response => response.data)
      .catch(error => errorHandler(error))
  ),
}
